/**
 * Created by pawel on 08.05.2014.
 */
export default class ControllerTouch {
  constructor(game, miniGame) {
    this.game = game;
    this.miniGame = miniGame;
    this.pointer = null;
  }

  start() {
    this.game.input.onDown.add(this.onInputDownHandler, this);
    this.game.input.onUp.add(this.onInputUpHandler, this);
    this.game.input.addMoveCallback(this.onInputMoveHandler, this);
  }

  stop() {
    this.game.input.onDown.remove(this.onInputDownHandler, this);
    this.game.input.onUp.remove(this.onInputUpHandler, this);
    this.game.input.deleteMoveCallback(this.onInputMoveHandler, this);
  }

  onInputDownHandler(pointer) {
    if (!this.pointer) {
      this.pointer = pointer;

      this.detect = true;
      this.x = pointer.x;
      this.y = pointer.y;
      this.counter = 0;
    }
  }

  onInputUpHandler(pointer) {
    if (this.pointer == pointer) {
      this.pointer = null;

      this.detect = false;
      // this.hero.releaseActionA();
      // this.hero.releaseActionB();
    }
  }

  onInputMoveHandler(pointer, x, y) {
    if (this.pointer == pointer) {
      this.counter++;
      if (this.detect && this.counter > 1) {
        this.detect = false;
        var dx = x - this.x;
        var dy = y - this.y;
        if (dy < 0) {
          this.miniGame.swipeUp();
        } else if (dy > 0) {
          this.miniGame.swipeDown();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ControllerTouch.js